import { GetStaticPropsResult } from 'next';

import { getRutilusGraphqlClient } from '../../src/api/graphql/getRutilusGraphqlClient';
import { queryRutilusStatic } from '../../src/api/graphql/queryRutilusStatic';
import { AppLogic } from '../../src/components/AppLogic/AppLogic';
import { GlobalLayout } from '../../src/components/Layouts/GlobalLayout';
import { DISCOVER_PAGES_NAV_LINKS } from '../../src/constants/constants';
import { REVALIDATE } from '../../src/constants/next';
import { GetMostActiveWaters } from '../../src/interfaces/graphql';
import { IPageMetadata } from '../../src/interfaces/nextjs';
import { getMostActiveWaters } from '../../src/queries/rutilus/Statistics';
import {
  PopularFishingWaters,
  IPopularFishingWatersProps,
} from '../../src/views/PopularFishingWaters/PopularFishingWaters';

export async function getStaticProps(): Promise<
  GetStaticPropsResult<IPageMetadata & IPopularFishingWatersProps>
> {
  const client = getRutilusGraphqlClient({ serverMode: 'static' });
  const { response } = await queryRutilusStatic<GetMostActiveWaters>(client, {
    query: getMostActiveWaters,
  });

  const allTimeWaters = response ? response.data.statistics.mostActiveWaters : [];
  const lastWeekWaters = response ? response.data.statistics.mostActiveWatersLastWeek : [];

  return {
    props: {
      _page: 'Place',
      _pageTitle: 'Find Spots, Species & Tips',
      allTimeWaters,
      lastWeekWaters,
    },
    revalidate: REVALIDATE.HOURLY,
  };
}

PopularFishingWaters.getLayout = function getLayout(page: any) {
  return (
    <AppLogic pageProps={page.props}>
      <GlobalLayout siteSubNavigationLinks={DISCOVER_PAGES_NAV_LINKS}>{page}</GlobalLayout>
    </AppLogic>
  );
};

export default PopularFishingWaters;
